import React, { Component, Fragment } from "react";
import { Footer } from "../general";
import { ModernHeader } from "../modern";

class ModernServicePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: null,
    };
  }

  componentDidMount() {
    // Smooth scroll to sections
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setState({ activeSection: entry.target.id });
          }
        });
      },
      { threshold: 0.3 },
    );

    const sections = document.querySelectorAll(".service-feature");
    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }

  scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 200;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  render() {
    const {
      title,
      subtitle,
      description,
      features = [],
      images = [],
      benefits = [],
      navigationItems = [],
      whatsappMessage,
      whatsappNumber = "56961922323",
    } = this.props;

    const whatsappUrl = `https://wa.me/${whatsappNumber}${
      whatsappMessage ? `?text=${encodeURIComponent(whatsappMessage)}` : ""
    }`;

    return (
      <Fragment>
        <ModernHeader />

        <div className="modern-service-page">
          {/* Hero Section */}
          <div className="modern-service-hero">
            <div className="auto-container">
              <h1 className="animate-fade-in-up">{title}</h1>
              <p
                className="subtitle animate-fade-in-up"
                style={{ animationDelay: "0.2s" }}
              >
                {subtitle}
              </p>
            </div>
          </div>

          {/* Navigation */}
          {navigationItems.length > 0 && (
            <div className="service-navigation">
              <div className="auto-container">
                <div className="service-nav-container">
                  {navigationItems.map((item, index) => (
                    <button
                      key={index}
                      className={`service-nav-item ${
                        this.state.activeSection === item.id ? "active" : ""
                      }`}
                      onClick={() => this.scrollToSection(item.id)}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Main Content */}
          <div className="modern-service-content">
            <div className="auto-container">
              <div className="service-content-wrapper">
                {/* Main Text Content */}
                <div className="modern-service-text animate-fade-in-up">
                  <h2>
                    {title
                      .replace("Asesorías ", "")
                      .replace("Auditoría de ", "")
                      .replace("Creación de ", "")}
                  </h2>

                  {description && <h4>{description}</h4>}

                  {/* Features Grid */}
                  <div className="service-features">
                    {features.map((feature, index) => (
                      <div
                        key={index}
                        id={`feature-${index}`}
                        className="service-feature"
                        style={{ animationDelay: `${0.1 * index}s` }}
                      >
                        <h5>
                          <span className="service-feature-icon">
                            {feature.emoji || feature.icon}
                          </span>
                          {feature.title}
                        </h5>
                        <p>{feature.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Sidebar */}
                <div
                  className="modern-service-sidebar animate-fade-in-up"
                  style={{ animationDelay: "0.3s" }}
                >
                  {/* Images */}
                  {images.map((image, index) => (
                    <div key={index} className="service-image-card">
                      <img src={image.src} alt={image.alt} />
                    </div>
                  ))}

                  {/* Benefits */}
                  {benefits.length > 0 && (
                    <div className="service-benefits">
                      <h3>¿Por qué elegirnos?</h3>
                      <ul className="benefits-list">
                        {benefits.map((benefit, index) => (
                          <li key={index}>{benefit}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Contact Card */}
                  <div className="service-contact-card">
                    <h4 className="white">¿Necesitas este servicio?</h4>
                    <p>
                      Contáctanos ahora y recibe una cotización personalizada
                    </p>
                    <a
                      href={whatsappUrl}
                      className="service-contact-button"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-whatsapp"></i>
                      Contactar Ahora
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="modern-service-cta animate-fade-in-up">
            <div className="auto-container">
              <div className="modern-service-cta-content">
                <h3>
                  ¿Necesitas {title.toLowerCase()}? Contasi es tu mejor opción
                </h3>
                <p>
                  Con más de 20 años de experiencia, somos el equipo de
                  profesionales que necesitas para hacer crecer tu negocio de
                  manera segura y eficiente.
                </p>
                <a
                  href={whatsappUrl}
                  className="modern-cta-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contáctanos por WhatsApp
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </Fragment>
    );
  }
}

export default ModernServicePage;
